/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import FormInputs from "../../FormInputs";
import {updateCmsText} from "../../../api/admin/cmsReq";
import useAuth from "../../../hooks/useAuth";
import {useParams} from "react-router-dom";
import FormButtons from "../../../components/common/FormButtons";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";
import useData from "../../../hooks/useData";
import Icon from "../../../components/common/Icon";


export default function FormCmsText({ setShowModal, category, apiCmsTextInfos}) {

    const { auth } = useAuth();
    const token = auth?.token;
    const { id } = useParams();
    const { cmsTextInfos } = useData();
    const [values, setValues] = useState();

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        if (e.target.type === "checkbox") {
            setValues({...values, [e.target.name] : e.target.checked})
        }
        validateFormInput(e)
    };

    const handleHtmlContent = (e, inputName) => {
        setValues({...values, [inputName] : e})
    };

    useEffect(() => {
        setValues(cmsTextInfos)
    }, [ cmsTextInfos ]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: parseInt(id),
            title : values?.title,
            content : values?.content,
            updatedAt : values?.updatedAt,
            hasTitle : values?.hasTitle || false,
            category: category,
            position: parseInt(values?.position),
        }
        updateCmsText(token, body)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiCmsTextInfos();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = (e) => {
        setShowModal(false)
    };

    const inputs = [
        {
            id : 1,
            name : "title",
            type : "text",
            placeholder : "Titre de l'article",
            label : "Titre de l'article",
            pattern : patternListChoices?.name,
            value : values?.title,
            required : true,
        },
        {
            id : 2,
            type : "number",
            name : "position",
            placeholder : "Position de l'article",
            label : "Position de l'article",
            values : values?.position,
            required : true,
        },
        {
            id : 3,
            name : "content",
            type : "html",
            placeholder : "Contenu",
            label : "Contenu",
            required: true,
            content : values?.content,
        },
        {
            id : 4,
            name : "hasTitle",
            type : "checkbox",
            label : "L'article a un titre ?",
        },
    ];

    return(
        <form onSubmit={handleSubmit} method="post" noValidate>
            <fieldset>
                <Icon source="fa-solid fa-file-lines" span={id == 0 ? "Créer un article" : "Modifier l'article"} />
                {inputs.map(input => (
                    <FormInputs
                        type={input.type}
                        name={input.name}
                        id={input.id}
                        label={input.label}
                        placeholder={input.placeholder}
                        value={values?.[input.name]}
                        onChange={onChange}
                        onChangeHtml={(e) => handleHtmlContent(e, input.name)}
                        required={input.required}
                        options={input.options}
                        selected={input.selected}
                        checked={input.checked}
                        multiple={input.multiple}
                        key={input.id + input.name}
                        pattern={input.pattern}
                        content={input.content}
                    />
                ))}
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    );
}